import { ResponsiveFrame } from "@circle-react-shared/ResponsiveFrame";
import { useBroadcastPreviewContent } from "./useBroadcastPreviewContent";

export const VisualBuilderPreviewContent = () => {
  const { visualEmailBuilderContentHtml, isLoading } =
    useBroadcastPreviewContent();

  if (!isLoading && visualEmailBuilderContentHtml) {
    return (
      <ResponsiveFrame
        initialContent={visualEmailBuilderContentHtml}
        shouldAdaptHeightToContentSize
        style={{ position: "relative" }}
      >
        <div />
      </ResponsiveFrame>
    );
  }

  return null;
};
